import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { getMeetingTitleByMeeting } from 'app/utils/appHelpers';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function ReportDecisionCountInfoTable({ data }) {
  const includeSameCount = data.some(item => Number(item.sameCount) > 0);
  const includeSaltCount = data.some(item => Number(item.saltCount) > 0);

  const { baseFontSize } = useTemplateFontSettings()

  return (
    <>
      <Typography variant="h6" align="center">
        {data.length > 0 ? getMeetingTitleByMeeting(data[0]) : ""}
      </Typography>
      <Table size="small" sx={{ borderRadius: 3, fontSize: baseFontSize }}>
        <TableHead sx={{ backgroundColor: "lightgrey" }}>
          <TableRow>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>Konu</TableCell>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>Madde Sayısı</TableCell>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>Kabul Sayısı</TableCell>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>Ret Sayısı</TableCell>
            {includeSameCount && (
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>Eşit Oy Sayısı</TableCell>
            )}
            {includeSaltCount && (
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>Salt Çoğunluk Sağlanamadı Sayısı</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.subjectName}</TableCell>
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.decisionCount}</TableCell>
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.acceptCount}</TableCell>
              <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.rejectCount}</TableCell>
              {includeSameCount && (
                <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.sameCount}</TableCell>
              )}
              {includeSaltCount && (
                <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.saltCount}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}

export default ReportDecisionCountInfoTable;
